module.exports = __webpack_public_path__ + "static/media/contlabs_white.431b110d.png";